import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class RecordTrashCar extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/tariff/trash/car'
    super(store, path)
  }
}
